import { jsx as _jsx } from "react/jsx-runtime";
import _AltDateWidget from '../AltDateWidget';
function AltDateTimeWidget(props) {
    const { AltDateWidget } = props.registry.widgets;
    return _jsx(AltDateWidget, { ...props, showTime: true });
}
AltDateTimeWidget.defaultProps = {
    ..._AltDateWidget.defaultProps,
    showTime: true,
};
export default AltDateTimeWidget;
//# sourceMappingURL=AltDateTimeWidget.js.map